import React from 'react'
import { useTheme } from '@mui/material'
import { LoginCurve } from 'iconsax-react'

import { LoginTitle } from '../../../atoms/Login'
import Button from '../Button'
import Environment from '../Environment'

import { useLoginState } from '../../../../providers/LoginStateProvider'
import useStyles from './styles'

const SelectEnvironment = ({ accounts, select, environments }) => {
  const theme = useTheme()

  const { accountError } = useLoginState()

  const classes = useStyles()

  const [chosen, setChosen] = React.useState(null)

  return (
    <div className={classes.root}>
      <div className={classes.boxBG} />
      <div style={{ padding: '1rem' }}>
        <LoginTitle title='SELECT ENVIRONMENT' size={theme.size.base} />
      </div>

      {accountError && <div className={classes.error}>{accountError}</div>}

      <div className={classes.envContainer}>
        {accounts.map((val, i) => {
          return (
            <Environment
              key={i}
              name={val.name}
              active={val === chosen}
              onClick={() => {
                setChosen(val)
                environments(val)
              }}
            />
          )
        })}
      </div>

      <div style={{ paddingTop: '1rem' }}>
        <Button
          disabled={!chosen}
          onClick={() => select(true)}
          className={classes.enter}
        >
          Enter
          <LoginCurve className={classes.icon} />
        </Button>
      </div>
    </div>
  )
}

export default SelectEnvironment
